import { useEffect, useState } from 'react'

type UseEffectUntilResolve = (
  effect: (resolve: () => void) => void,
  deps: unknown[],
) => boolean

/**
 * @description useMount 的變形，可以確保所有非同步資料準備完畢後才執行 effect
 *
 * 在 effect 被 resolve 之前，效果同 useEffect，被 resolve 之後，則不再運行
 *
 * @example
 * useEffectUntilResolve(async (resolve) => {
 *   if(isLoading) return;
 *   resolve();
 *   await handleReady();
 * },[isLoading,handleReady])
 */
const useEffectUntilResolve: UseEffectUntilResolve = (effect, deps) => {
  const [isResolved, setIsResolved] = useState(false)
  useEffect(() => {
    if (isResolved) {
      return
    }

    effect(() => setIsResolved(true))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)

  return isResolved
}

export default useEffectUntilResolve
